module.exports = __webpack_public_path__ + "img/fig02.d8e38adc.jpg";